import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

interface SurchargeDateBlockPayload {
  surchargeDateBlock: Record<string, unknown>;
  propertyId: string;
  roomTypeId: string;
  roomRateId: string;
}

export function useCreateSurchargeDateBlocks() {
  return useMutation({
    mutationFn: async (payloads: Array<SurchargeDateBlockPayload>) => {
      for (const update of payloads) {
        await ReservationService.createSurchargeDateBlock(
          update.surchargeDateBlock,
          update.propertyId,
          update.roomTypeId,
          update.roomRateId,
          true,
        );
      }
    },
  });
}
